/**
 * The manual UTC offsets a ship can be set to, in hours east of UTC, ascending.
 *
 * Real-world offsets only, and only the ones relevant to marine navigation: whole
 * hours from -12 to +14 plus the half-hour zones. The quarter-hour zones (Nepal's
 * +5:45, Chatham's +12:45, the Australian +8:45) are deliberately omitted, as is
 * -2:30, which the legacy timezone input used to offer even though no such offset
 * exists.
 *
 * This is the single source of truth for both the ship-settings offset select and
 * the legacy `TimezoneInput`'s accepted values, which used to carry two hardcoded
 * lists that disagreed with each other.
 */
export const TIMEZONE_OFFSETS_HOURS: number[] = [
  -12, -11, -10, -9.5, -9, -8, -7, -6, -5, -4, -3.5, -3, -2, -1,
  0,
  1, 2, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 8, 9, 9.5, 10, 10.5, 11, 12, 13, 14,
];

/** The same offsets in seconds, the unit a ship's `timezone` is stored and edited in. */
export const TIMEZONE_OFFSETS_SECONDS: number[] = TIMEZONE_OFFSETS_HOURS.map((hours) => hours * 3600);
